export default __webpack_public_path__ + "static/portfolio-4-0630f7a30667033b90351b333454d0c3.jpg";